import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NavBarPathway from './NavBar/NavBarPathway';
import { logData } from '../api.js';
import { useAuth } from '../useAuth';
import '../index.css';

function PathwaySelection() {
    const [module, setModule] = useState('');
  const navigate = useNavigate();
  const auth = useAuth();
  const rc = auth.getResearchCode();

  const [customTheme, setCustomTheme] = useState('');


  useEffect(() => {
    logData(rc, 'PATHWAY_SELECTION_LOADED', {});
    const savedModule = localStorage.getItem('selectedModule');
    if (savedModule) {
      logData(rc, 'PATHWAYSELECTION_SAVED_MODULE_FOUND', { savedModule });
      setModule(savedModule);
    }
  }, [rc]);

  const handleThemeInput = (theme) => {
    logData(rc, 'THEMESTORMER_THEME_INPUT', { selected: theme });
    localStorage.setItem('projectTheme', theme);
    localStorage.setItem('notUseThemeStormer', 'true');
    localStorage.setItem('enableProjectIdeaGeneration', 'true');
    navigate('/projectstormer');
  };

  const handlePathwaySelect = (pathwayName) => {
    logData(rc, 'PATHWAY_SELECTED', { selected: pathwayName });
    localStorage.setItem('selectedPathway', pathwayName);
    localStorage.removeItem('notUseThemeStormer');
    localStorage.setItem('enableThemeGeneration', 'true'); // to prevent regenerating themes if returning from ProjectStormer later
    navigate('/themestormer');
  };

  const renderCustomThemeInput = () => (
    <div>
      <input
        type="text"
        className="form-control"
        value={customTheme}
        onChange={(e) => setCustomTheme(e.target.value)}
      />
      <div className="text-start">
        <button
          className="btn btn-primary mt-4"
          onClick={() => handleThemeInput(customTheme)}
          disabled={!customTheme.trim()}
        >
          Use My Theme
        </button>
      </div>
    </div>
  );

  return (
    <div className="row flex-nowrap">
      {/* Navbar */}
      <NavBarPathway />

      {/* Main Content */}
      <div className="col py-3">
        {/*<h1 className="text-center fw-bold mb-5">Conjuror for Scratch Encore</h1>*/}
        <div className="text-center">
          <img src={require("../assets/images/conjurorlogo.png")} className="w-25 mb-5" alt="logo"></img>
        </div>

        <div className="container w-75">
          <h5 className="fw-bold">Let's figure out a theme for your <span className="text-decoration-underline">{module || '[Module]'}</span> module.</h5>
          <p className="mb-5">Choose <span className="text-primary fw-bold">ONE</span> of the options below to brainstorm theme ideas.</p>
        </div>

        <div className="container w-75 d-grid gap-2 mb-5">

          <div className="row justify-content-md-center">

            <div className="text-center col-sm">
              <img src={require("../assets/images/integration.png")} className="w-50 mb-4" alt="academic integration"></img>
              <div className="btn btn-primary w-75 fw-bold" onClick={() => handlePathwaySelect('Academic Integration')}>Academic subject integration</div>
            </div>

            <div className="text-center col-sm">
              <img src={require("../assets/images/holidays.png")} className="w-50 mb-4" alt="cultural holidays"></img>
              <div className="btn btn-primary w-75 fw-bold" onClick={() => handlePathwaySelect('Holidays and Traditions')}>Holiday and cultural traditions</div>
            </div>

            <div className="text-center col-sm">
              <img src={require("../assets/images/interests.png")} className="w-50 mb-4" alt="student interests"></img>
              <div className="btn btn-primary w-75 fw-bold" onClick={() => handlePathwaySelect('Interests and Local Events')}>Student interests and local events</div>
            </div>

          </div>
        </div>

        <div className="container w-75">
           <p>Or if you already have a theme idea, just <span className="text-primary fw-bold">enter</span> it below.</p>
           {renderCustomThemeInput()}
        </div>
      </div>
    </div>
  );
}

export default PathwaySelection;